import { attributes } from '@/content/services/software_development.md'
import ServicesTemplate from '@/organisms/ServicesTemplate'

export default function ServicesSoftwareDevelopment() {
  return <ServicesTemplate attributes={attributes} />
}
